import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var RemoveServicesMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation RemoveServices($input: [RemoveServicesInput!]!, $basketId: ID!) {\n    removeServices(input: $input, basketId: $basketId)\n  }\n"])));
export default RemoveServicesMutation;